import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostKey, getPostsKey, getPinnedPostsKey } from '../../utils/keys';
export const useUnpinPostFromSpace = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(variables => client.posts.unpinFromSpace(variables), {
        onSettled: (data, error, variables) => {
            const postKey = getPostKey({ variables: { id: variables === null || variables === void 0 ? void 0 : variables.postId } });
            queryClient.invalidateQueries(postKey);
            const postsKey = getPostsKey();
            queryClient.invalidateQueries(postsKey);
            const pinnedPostsKey = getPinnedPostsKey();
            queryClient.invalidateQueries(pinnedPostsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUnpinPostFromSpace.js.map